<template>
  <div class="welcome">
    <h1>{{message}}</h1>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
  data () {
    return {
      message: 'Welcome!!'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .welcome{
    margin: 0px auto;
    max-width: 350px;
    position: relative;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// Welcome.vue?4c54ee2c